import type { ComponentInstance, FieldValue } from './types';

/**
 * 字段取值。所有取值函数都返回 `number | null`：
 * `null` 表示「用户没有提供可用数值」，调用方必须据此走缺失提示，而不是当成 0。
 */
export function asNumber(value: FieldValue): number | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}

/** 重量、电流、尺寸这类不允许为负的量：负数视为无效输入（等同未填）。 */
export function asNonNegative(value: FieldValue): number | null {
  const parsed = asNumber(value);
  if (parsed === null || parsed < 0) return null;
  return parsed;
}

/** 数量：至少为 1，非法值回落到 1，避免出现除零或整行不参与计算。 */
export function normalizedQty(component: ComponentInstance): number {
  const parsed = asNumber(component.qty);
  if (parsed === null || parsed < 1) return 1;
  return Math.floor(parsed);
}

export function fieldNumber(component: ComponentInstance, key: string): number | null {
  return asNonNegative(component.fields[key]);
}

export function hasField(component: ComponentInstance, key: string): boolean {
  const value = component.fields[key];
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  return true;
}
